import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

// Components
import { Icon } from 'antd';
import withTracker from './components/common/withTracker';
import PrivateRoute from './components/common/PrivateRoute';
import Dashboard from './components/dashboard';
import Homes from './components/homes';
import Administration from './components/administration';
import Tests from './components/tests';
import SmartTraining from './components/training';
import HomeDetail from './components/homes/detail';
import ApplicationView from './components/common/ApplicationView';
import Invitation from './components/invitation';
import Reports from './components/reports';
import Mobile from './mobile';

// Selectors
import { isRoleAdministrator, isRoleTester } from './data/auth/selectors';

// Others
import { strings } from './localization';
import { ROUTE_NAMES } from './utils';

const Routes = ({ logout, isAdmin, isTester, activePath }) => {
    const protectedRoutes = [
        {
            path: ROUTE_NAMES.DASHBOARD,
            main: withTracker(Dashboard),
            sidebar: (
                <span>
                    <Icon type="appstore" /> {strings.dashboardRoute}
                </span>
            )
        }, {
            path: ROUTE_NAMES.TRAIN,
            main: withTracker(SmartTraining),
            sidebar: (
                <span>
                    <Icon type="book" /> {strings.training.route}
                </span>
            )
        }, {
            path: ROUTE_NAMES.REPORTS,
            main: withTracker(Reports),
            sidebar: (
                <span>
                    <Icon type="snippets" /> {strings.reports.route}
                </span>
            )
        }
    ];

    if (isAdmin) {
        protectedRoutes.push({
            path: ROUTE_NAMES.ADMINISTRATION,
            main: withTracker(Administration),
            sidebar: (
                <span>
                    <Icon type="setting" /> {strings.administration.route}
                </span>
            )
        });
    } else {
        protectedRoutes.push({
            path: ROUTE_NAMES.HOMES,
            main: withTracker(Homes),
            sidebar: (
                <span>
                    <Icon type="deployment-unit" /> {strings.homes.route}
                </span>
            )
        });
    }
    if (isTester) {
        protectedRoutes.push({
            path: ROUTE_NAMES.TESTS,
            main: withTracker(Tests),
            sidebar: (
                <span>
                    <Icon type="check-circle" /> {strings.tests.route}
                </span>
            )
        });
    }

    return (
        <div>
            {/* Public routes */}
            <ApplicationView protectedRoutes={protectedRoutes} logout={logout}>
                <Switch location={{pathname: activePath}}>
                    {protectedRoutes
                        .filter(r => r)
                        .map(route => (
                            <PrivateRoute
                                key={`route-${route.path}`}
                                path={route.path}
                                exact={route.exact}
                                component={route.main}
                                logout={null}
                            />
                        ))}

                    <PrivateRoute
                        key={`route-${ROUTE_NAMES.HOME_DETAIL}`}
                        path={ROUTE_NAMES.HOME_DETAIL}
                        component={withTracker(HomeDetail)}
                        logout={null}
                    />

                    <PrivateRoute
                        key={`route-${ROUTE_NAMES.INVITATION_OWNER}`}
                        path={ROUTE_NAMES.INVITATION_OWNER}
                        component={withTracker(Invitation)}
                        logout={logout}
                    />
                    <PrivateRoute
                        key={`route-${ROUTE_NAMES.INVITATION}`}
                        path={ROUTE_NAMES.INVITATION}
                        component={withTracker(Invitation)}
                        logout={logout}
                    />

                    <Route
                        key={`route-${ROUTE_NAMES.MOBILE}`}
                        path={ROUTE_NAMES.MOBILE}
                        component={withTracker(Mobile)}
                    />

                    <Redirect from={ROUTE_NAMES.APP} to={ROUTE_NAMES.DASHBOARD} />
                    <Route key="not-found" component={() => <div>TODO: Not Found</div>} />
                </Switch>
            </ApplicationView>
        </div>
    );
};

export default connect((state, ownProps) => ({
    ...ownProps,
    isAdmin: isRoleAdministrator(state),
    isTester: isRoleTester(state),
    activePath: state.router.location.pathname
}))(Routes);
